import React, { useState, useEffect } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Button, Grid, Icon, LinearProgress, TextField } from "@mui/material";
import moment from "moment";
import dayjs from "dayjs";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { fetchData, currentFormat } from "../js/main";
import { conf } from "../const";

function getBills(form) {
  return new Promise(async (resolve) => {
    let fromDate = moment(form.fromDate).format("YYYY-MM-DD");
    let toDate = moment(form.toDate).format("YYYY-MM-DD");
    fromDate += "T" + form.fromTime + ":00+07:00";
    toDate += "T" + form.toTime + ":00+07:00";
    const match = {
      $and: [
        { transactionDateandTime: { $gte: fromDate } },
        { transactionDateandTime: { $lte: toDate } },
        { "operator.usn": form.usn },
      ],
    };
    let options = {
      match,
      sort: { bill_id: 1 },
    };
    let Bills = await fetchData("post", "/v3/bill/report", options);
    resolve(Bills);
  });
}

export default function RptDelivery(props) {
  const [form, setForm] = useState();
  const [loading, setLoading] = useState(false);
  const [bills, setBills] = useState(false);
  const [deliveries, setDeliveries] = useState();

  useEffect(() => {
    (async () => {
      if (props.profile) {
        const dt = new Date();
        const deliveries = await fetchData("post", "/v3/delivery", {
          match: { $and: [{ usn: props.profile.usn }] },
          select: "fromDate fromTime toDate toTime -_id",
        });
        if (deliveries) setDeliveries(deliveries.result);
        setForm({
          // fromDate: dt,
          fromDate: new Date("2024-02-04"),
          fromTime: "00:00",
          toDate: dt,
          toTime: moment().format("HH:mm"),
          usn: props.profile.usn,
        });
      }
    })();
  }, [props]);

  useEffect(() => {
    (async () => {
      if (form) {
        setLoading(true);
        let bills = await getBills(form);
        setBills(bills);
        setLoading(false);
      }
    })();
  }, [form]);

  return (
    <div>
      {form && deliveries && (
        <>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid container spacing={2} sx={{ marginTop: "20px" }}>
              <Grid item xs={12} sm={6} md={3}>
                <DatePicker
                  format="DD MMM YYYY"
                  onChange={(newValue) =>
                    setForm({ ...form, fromDate: new Date(newValue) })
                  }
                  label="Form Date"
                  value={dayjs(form.fromDate)}
                  slotProps={{
                    textField: {
                      InputLabelProps: { shrink: true },
                      fullWidth: true,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  type="time"
                  fullWidth
                  value={form.fromTime}
                  onChange={(e) =>
                    setForm({ ...form, fromTime: e.target.value })
                  }
                  label="From Time"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <DatePicker
                  format="DD MMM YYYY"
                  onChange={(newValue) =>
                    setForm({ ...form, toDate: new Date(newValue) })
                  }
                  label="To Date"
                  value={dayjs(form.toDate)}
                  slotProps={{
                    textField: {
                      InputLabelProps: { shrink: true },
                      fullWidth: true,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  type="time"
                  fullWidth
                  value={form.toTime}
                  onChange={(e) => setForm({ ...form, toTime: e.target.value })}
                  label="To Time"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </LocalizationProvider>
          {bills && deliveries && (
            <ReportTable
              form={form}
              loading={loading}
              bills={bills}
              deliveries={deliveries}
            />
          )}
        </>
      )}
    </div>
  );
}

function ReportTable({ form, loading, bills, deliveries }) {
  const [total, setTotal] = useState();
  const [dialogState, setDialogState] = useState({ open: false });
  const tableHeads = [
    { label: "ประเภทรายได้" },
    { label: "การรับเงิน" },
    { label: "ใบเสร็จเลขที่" },
    { label: "เวลารับเงิน" },
    { label: "จำนวนเงิน" },
    { label: "หมายเหตุ", style: { width: "1.5cm" } },
  ];

  useEffect(() => {
    let total = {
      amount: 0,
      cash: 0,
      transfer: 0,
      canceled_count: 0,
    };
    for (const bill of bills.result) {
      if (bill.canceled.status === true) total.canceled_count++;
      else {
        const amount = parseFloat(bill.amount);
        total.amount += amount;
        if (bill.transactionType === "Domestic Transfers")
          total.transfer += amount;
        else total.cash += parseFloat(bill.amount);
      }
    }
    setTotal(total);
  }, [bills]);

  async function print() {
    let print = {
      headers: [
        { label: "หลักฐานการส่งเงิน" },
        {
          label: `ตั้งแต่ ${moment(form.fromDate).format("DD MMM YYYY")} เวลา ${
            form.fromTime
          } น. ถึง ${moment(form.toDate).format("DD MMM YYYY")} เวลา ${
            form.toTime
          } น.`,
        },
      ],
      table: {
        cols: tableHeads,
        rows: [],
        total,
      },
    };
    print.table.rows = await bills.result.map((bill) => {
      let r = {
        col_0: [],
        col_1: bill.transactionType,
        col_2: bill.bill_id,
        col_3: moment(bill.transactionDateandTime).format("DD MMM YYYY, HH:mm"),
        col_4: currentFormat(bill.amount),
        col_5: bill.canceled.status === true ? "ยกเลิก" : "",
      };
      for (const detail of bill.invoice_id.details) {
        r.col_0.push({ label: detail.biller_name });
      }
      return r;
    });
    let cookie = JSON.parse(localStorage.getItem(conf.cookiePrint));
    if (!cookie) cookie = { print: {} };
    cookie.print = print;
    localStorage.setItem(conf.cookiePrint, JSON.stringify(cookie));
    document.getElementById("printFrame").src =
      process.env.PUBLIC_URL + "/print/delivery";
  }
  function openDialog() {
    const open = !dialogState.open;
    setDialogState({ ...dialogState, open, total, form, bills: bills.result });
  }

  function saveDisabled() {
    let r = false;
    let fromDate = moment(form.fromDate).format("YYYY-MM-DD");
    let key = deliveries.findIndex((j) => j.toDate > fromDate);
    if (key > -1) r = true;
    else {
      key = deliveries.findIndex(
        (j) => j.toDate === fromDate && j.toTime > form.fromTime
      );
      if (key > -1) r = true;
    }
    return r;
  }
  return (
    <div style={{ textAlign: "center", paddingTop: "10px" }}>
      <ConfirmDialog state={dialogState} onClose={openDialog} />
      <h2 className="bold">หลักฐานการส่งเงิน</h2>
      <div className="bold" style={{ marginBottom: "15px" }}>
        ตั้งแต่ {moment(form.fromDate).format("DD MMM YYYY")} เวลา{" "}
        {form.fromTime} น. ถึง {moment(form.toDate).format("DD MMM YYYY")} เวลา{" "}
        {form.toTime} น.
      </div>
      {loading === true && <LinearProgress />}
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {tableHeads.map((head, key) => (
                <TableCell key={key}>{head.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {bills.result.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={7}
                  align="center"
                  sx={{ color: "#888", lineHeight: "60px" }}
                >
                  No bill found
                </TableCell>
              </TableRow>
            ) : (
              <>
                {bills.result.map((bill) => (
                  <TableRow key={bill._id} hover>
                    <TableCell>
                      {bill.invoice_id.details.map((detail, key) => (
                        <div
                          key={key}
                          style={key > 0 ? { marginTop: "5px" } : {}}
                        >
                          {key + 1}. {detail.biller_name}
                        </div>
                      ))}
                    </TableCell>
                    <TableCell align="center">{bill.transactionType}</TableCell>
                    <TableCell align="center">{bill.bill_id}</TableCell>
                    <TableCell align="center">
                      {moment(bill.transactionDateandTime).format(
                        "DD MMM YYYY, HH:mm"
                      )}
                    </TableCell>
                    <TableCell align="center">
                      {currentFormat(bill.amount)}
                    </TableCell>
                    <TableCell align="center">
                      {bill.canceled.status === true && (
                        <span style={{ color: "#f00" }}>ยกเลิก</span>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
                {total && (
                  <>
                    <TableRow>
                      <TableCell colSpan={4} className="bold" align="right">
                        รวมเป็นเงิน
                      </TableCell>
                      <TableCell className="bold" align="right">
                        {currentFormat(total.amount)}
                      </TableCell>
                      <TableCell className="bold">บาท</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={4} className="bold" align="right">
                        เงินสด
                      </TableCell>
                      <TableCell className="bold" align="right">
                        {currentFormat(total.cash)}
                      </TableCell>
                      <TableCell className="bold">บาท</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={4} className="bold" align="right">
                        เงินโอน
                      </TableCell>
                      <TableCell className="bold" align="right">
                        {currentFormat(total.transfer)}
                      </TableCell>
                      <TableCell className="bold">บาท</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={4} className="bold" align="right">
                        รายการยกเลิก
                      </TableCell>
                      <TableCell className="bold" align="right">
                        {total.canceled_count}
                      </TableCell>
                      <TableCell className="bold">รายการ</TableCell>
                    </TableRow>
                  </>
                )}
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{ textAlign: "right" }}>
        <Button
          sx={{ marginTop: "15px", width: "200px" }}
          variant="contained"
          startIcon={<Icon>save</Icon>}
          onClick={openDialog}
          color="success"
          disabled={saveDisabled()}
        >
          <div>ส่งหลักฐานการส่งเงิน</div>
        </Button>
        <Button
          sx={{ margin: "15px auto auto 8px", width: "200px" }}
          variant="contained"
          startIcon={<Icon>print</Icon>}
          onClick={print}
        >
          <div>ยืนยัน / Print</div>
        </Button>
      </div>
    </div>
  );
}

function ConfirmDialog({ state, onClose }) {
  const [form, setForm] = useState();
  useEffect(() => {
    if (state && state.open === true) {
      setForm({
        total: state.total,
        coin_amount: 0,
        banknote_amount: 0,
        fromDate: moment(state.form.fromDate).format("DD MMM YYYY"),
        fromTime: state.form.fromTime,
        toDate: moment(state.form.toDate).format("DD MMM YYYY"),
        toTime: state.form.toTime,
      });
    }
  }, [state]);

  function changeAmount(field, value) {
    value = parseFloat(value) || 0;
    let targetField = "banknote_amount";
    let targetValue = form.total.cash - value;
    if (field === targetField) targetField = "coin_amount";

    setForm({ ...form, [field]: value, [targetField]: targetValue });
  }

  async function sendDelivery() {
    let send = { ...form };
    send.fromDate = moment(state.form.fromDate).format("YYYY-MM-DD");
    send.toDate = moment(state.form.toDate).format("YYYY-MM-DD");
    send.bills = state.bills;
    await fetchData("put", "/v3/delivery", send);
    onClose();
  }
  return (
    <div>
      {form && (
        <Dialog open={state.open}>
          <DialogTitle id="alert-dialog-title">
            ยืนยันการบันทึการส่งเงิน
            <div style={{ fontSize: ".8rem" }}>
              เวลา {form.fromDate}, {form.fromTime} - {form.toDate},{" "}
              {form.toTime}
            </div>
          </DialogTitle>
          <DialogContent>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: "150px" }}>รายการ</TableCell>
                    <TableCell sx={{ width: "140px" }}>จำนวน (บาท)</TableCell>
                    <TableCell sx={{ width: "200px" }}>หมายเหตุ</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow hover>
                    <TableCell>เหรียญกษาปณ์</TableCell>
                    <TableCell className="inputPadding">
                      <TextField
                        fullWidth
                        size="small"
                        type="number"
                        inputProps={{ style: { textAlign: "center" } }}
                        value={form.coin_amount}
                        onChange={(e) =>
                          changeAmount("coin_amount", e.target.value)
                        }
                        onClick={(e) => e.target.select()}
                      />
                    </TableCell>
                    <TableCell className="inputPadding">
                      <TextField
                        fullWidth
                        size="small"
                        value={form.coin_remark || ""}
                        onChange={(e) =>
                          setForm({ ...form, coin_remark: e.target.value })
                        }
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow hover>
                    <TableCell>ธนบัตร</TableCell>
                    <TableCell className="inputPadding">
                      <TextField
                        fullWidth
                        size="small"
                        type="number"
                        inputProps={{ style: { textAlign: "center" } }}
                        value={form.banknote_amount}
                        onChange={(e) =>
                          changeAmount("banknote_amount", e.target.value)
                        }
                        onClick={(e) => e.target.select()}
                      />
                    </TableCell>
                    <TableCell className="inputPadding">
                      <TextField
                        fullWidth
                        size="small"
                        value={form.banknote_remark || ""}
                        onChange={(e) =>
                          setForm({ ...form, banknote_remark: e.target.value })
                        }
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
            <Grid container>
              <Grid item xs={6}>
                <Button
                  disabled={
                    form.total.cash !== form.coin_amount + form.banknote_amount
                  }
                  onClick={sendDelivery}
                >
                  Save
                </Button>
              </Grid>
              <Grid item xs={6} align="right">
                <Button onClick={onClose}>Close</Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}
